import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { PainSection } from '../components/PainSection';
import { SolutionSection } from '../components/SolutionSection';
import { StorySection } from '../components/StorySection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { BonusSection } from '../components/BonusSection';
import { PricingSection } from '../components/PricingSection';
import { SocialProofPopup } from '../components/SocialProofPopup';
export function SalesPage() {
  return <main className="min-h-screen bg-white font-body selection:bg-brand-gold/30 selection:text-brand-dark" data-id="element-166">
      <HeroSection data-id="element-167" />
      <PainSection data-id="element-168" />
      <SolutionSection data-id="element-169" />
      <StorySection data-id="element-170" />
      <BonusSection data-id="element-171" />
      <PricingSection data-id="element-172" />
      <TestimonialsSection data-id="element-173" />
      <SocialProofPopup data-id="element-174" />

      <footer className="bg-brand-dark text-gray-400 py-6 text-center text-sm border-t border-white/10" data-id="element-175">
        <div className="max-w-4xl mx-auto px-4" data-id="element-176">
          <p data-id="element-177">
            © {new Date().getFullYear()} Kit Inmobiliario PRO. Todos los
            derechos reservados.
          </p>
          <p className="mt-1 text-xs opacity-60" data-id="element-178">
            Este sitio no es parte del sitio web de Facebook o Facebook Inc.
            Además, este sitio NO está respaldado por Facebook de ninguna
            manera. FACEBOOK es una marca registrada de FACEBOOK, Inc.
          </p>
        </div>
      </footer>
    </main>;
}